import styled from 'styled-components'
import { AiOutlineClockCircle } from 'react-icons/ai'
import { Typography } from 'common/typography'
import { Play } from 'components/icons/index'
import { useCourse } from 'querys/course'

const CourseDescriptionStyled = styled.div`
  grid-area: duration;
  display: flex;
  .statistic-container {
    flex: 1;
    display: flex;
  }
  .statistic {
    margin-left: 8px;
  }
`

export default function CourseDescription() {
  const { data: { duration, stats: { num_lessons } } } = useCourse()
  return (
    <CourseDescriptionStyled>
      <div className="statistic-container">
        <Play color="var(--turquoise)" />
        <div className="statistic">
          <Typography small="regularBold" large="headline5">
            Duración
          </Typography>
          <Typography small="p2Regular" large="regular">
            {`${duration} hora${duration > 1 ? 's' : ''}`}
          </Typography>
        </div>
      </div>
      <div className="statistic-container">
        <AiOutlineClockCircle size={33} color="var(--turquoise)" />
        <div className="statistic">
          <Typography small="regularBold" large="headline5">
            Clases
          </Typography>
          <Typography small="p2Regular" large="regular">
            {`${num_lessons} lecciones`}
          </Typography>
        </div>
      </div>
    </CourseDescriptionStyled>
  )
}
